"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEntityDataTable = useEntityDataTable;
const DataTable_1 = require("@juvare/common-data-table-ui/DataTable");
const FiltersBar_1 = require("@juvare/common-data-table-ui/FiltersBar");
const react_1 = __importDefault(require("react"));
const useStorageBackendDataProvider_1 = require("./useStorageBackendDataProvider");
function useEntityDataTable(config, { useDataTableFunction = DataTable_1.useDataTableUsingState, ...otherParams }) {
    const columnsToFetch = new Set();
    config.columns.forEach((column) => {
        if (Array.isArray(column.storageColumn)) {
            column.storageColumn.forEach(columnsToFetch.add);
        }
        else if (column.storageColumn) {
            columnsToFetch.add(column.storageColumn);
        }
    });
    const result = useDataTableFunction({
        useDataProvider: (0, useStorageBackendDataProvider_1.useStorageBackendDataProvider)(config.entityName, config.mapEntityFilterData, columnsToFetch.size > 0 ? [...columnsToFetch] : undefined),
        defaultSortColumnKey: config.defaultSortColumnKey,
        ...otherParams,
    });
    return {
        ...result,
        dataTableProps: {
            ...result.dataTableProps,
            title: config.title,
            columns: config.columns,
            filtersBar: react_1.default.createElement(FiltersBar_1.FiltersBar, { ...result.filtersBarProps, config: config.filterConfig }),
            tableSx: config.tableSx,
        },
    };
}
